// extracted by mini-css-extract-plugin
export default {"Main_img_slider":"ProductModalImages_Main_img_slider__y45Lv"};